import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=4d1a18da&scoped=true"
import script from "./DiscountBanner.vue?vue&type=script&lang=js"
export * from "./DiscountBanner.vue?vue&type=script&lang=js"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=4d1a18da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a18da",
  null
  
)

export default component.exports